import PropTypes from 'prop-types';

const GRANT_SHAPE = {
  amount: PropTypes.number,
  description: PropTypes.string,
  location: PropTypes.string,
  name: PropTypes.string,
  programs: PropTypes.array,
  strategies: PropTypes.array,
  url: PropTypes.string,
  year: PropTypes.string,
};

const TAXONOMY_MAP = {
  id: PropTypes.number,
  name: PropTypes.string,
  slug: PropTypes.string,
};

export default {
  GRANT_SHAPE,
  TAXONOMY_MAP,
};
